<template>
  <div>
    <form
      ref="menububbleForm"
      class="menububble__form"
      tabindex="-1"
      @submit.prevent="setLinkUrl($refs.linkInput.value)"
    >
      <input
        ref="linkInput"
        class="menububble__input"
        type="text"
        :value="linkUrl"
        placeholder="Enter link and press enter"
        @keydown.esc="hideLinkMenu"
        @blur="onBlur"
      />
      <button
        ref="removeButton"
        class="removebtn"
        type="button"
        title="remove link"
        @click.stop="setLinkUrl(null)"
      >
        <svg-icon :width="'10'" :height="'10'" icon="app-icons/remove" />
      </button>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SvgIcon from '../all/SvgIcon.vue';

export default {
  components: {
    SvgIcon,
  },

  props: {
    getMarkAttrs: {
      type: Function,
      default: () => {},
    },
    linkCommand: {
      type: Function,
      default: () => {},
    },
    focusCommand: {
      type: Function,
      default: () => {},
    },
  },

  computed: {
    ...mapGetters('application/contextToolbar', ['getIsEmpty', 'getButtons']),
    isEmpty() {
      return this.getIsEmpty;
    },
    buttons() {
      return this.getButtons;
    },
    linkUrl: {
      get() {
        const attrs = this.getMarkAttrs();
        return attrs.href;
      },
    },
  },
  mounted() {
    this.$refs.linkInput.focus();
  },
  methods: {
    ...mapActions('application/contextToolbar', ['openSubmenu']),
    setLinkUrl(url) {
      let href = url;
      if (url && !url.startsWith('http://') && !url.startsWith('https://')) {
        href = `https://${url}`;
      }
      this.linkCommand({ href });
      this.hideLinkMenu();
      this.focusCommand();
    },

    hideLinkMenu() {
      this.openSubmenu({
        buttonId: null,
        anchor: null,
      });
    },

    onBlur(event) {
      if (
        event.relatedTarget !== this.$refs.removeButton &&
        event.relatedTarget !== this.$refs.menububbleForm
      ) {
        // do not hide in this case to accept the click
        this.hideLinkMenu();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.floatingtoolbar {
  position: absolute;
  top: 10px;
  left: 10px;
  background: #2c3233;
  box-shadow: 0px 8px 10px rgba(13, 14, 14, 0.25);
  border-radius: 4px;
  padding: 5px;
}
.removebtn {
  background: none;
  border: none;
  color: #c4c4c4;
  cursor: pointer;

  &:hover :deep(svg path) {
    fill: #fff;
  }
}

.menububble__input {
  width: 180px;
}
</style>
